import store from '@/store'

export default [
  {
    path: '/fee-groups',
    name: 'fee-group',
    meta: { requiresAuth: true },
    component: () => import('@/pages/fee-group/index.vue')
  },
  {
    path: '/fee-groups/create',
    name: 'fee-group-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/fee-group/create.vue')
  },
  {
    path: '/fee-groups/:id',
    name: 'fee-group-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/fee-group/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('feeGroup/find', to.params.id)
      next()
    }
  }
]
